import React, { useState } from 'react';
import { Box } from '@mui/material';
import ConsoleHeader from '../components/common/ConsoleHeader.tsx';
import { designTokens } from '../theme.ts';

function ProductRequirementForm() {
  // TODO: Need to apply useApi
  const [form, setForm] = useState({
    drawingnumber: '',
    companyname: '',
    sitename: '',
    salesclassification: '',
    orderdetails: '',
    orderamount: '',
    DeliveryDate: '',
    DeliveryTime: '',
    personincharge: '',
    leaseledger: '',
  });

  const API_BASE = process.env.REACT_APP_API;


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/product-req-rents`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          drawingnumber: parseInt(form.drawingnumber),
          orderamount: parseInt(form.orderamount),
          leaseledger: parseInt(form.leaseledger),
        })
      });

      if (res.ok) {
        alert("등록 성공!");
        setForm({
          drawingnumber: '',
          companyname: '',
          sitename: '',
          salesclassification: '',
          orderdetails: '',
          orderamount: '',
          DeliveryDate: '',
          DeliveryTime: '',
          personincharge: '',
          leaseledger: '',
        });
      } else {
        alert("등록 실패");
      }
    } catch (err) {
      console.error("요청 오류:", err);
      alert("에러 발생");
    }
  };

  return (
    <Box sx={{ fontFamily: designTokens.fonts.sans }}>
      <ConsoleHeader
        code="MARS · PROD · INTAKE"
        title="생산요청서 등록"
        meta="임대 생산 요청 등록"
      />
      <form onSubmit={handleSubmit} style={styles.form}>

        {fields.map(({ label, name, type, required }) => (
          <div style={styles.fieldGroup} key={name}>
            <label style={styles.label}>
              {label}{required && <span style={styles.required}>*</span>}
              <input
                type={type}
                name={name}
                value={form[name]}
                onChange={handleChange}
                required={required}
                style={styles.input}
              />
            </label>
          </div>
        ))}

        <button type="submit" style={styles.button}>등록</button>
      </form>
    </Box>
  );
}

// � 필드 구성 리스트
const fields = [
  { label: "도면번호", name: "drawingnumber", type: "number", required: true },
  { label: "업체명", name: "companyname", type: "text", required: true },
  { label: "현장명", name: "sitename", type: "text", required: true },
  { label: "매출구분", name: "salesclassification", type: "text", required: false },
  { label: "수주내용", name: "orderdetails", type: "text", required: false },
  { label: "수주금액", name: "orderamount", type: "number", required: true },
  { label: "납기일자", name: "DeliveryDate", type: "date", required: true },
  { label: "납기시간", name: "DeliveryTime", type: "time", required: false },
  { label: "작성담당자", name: "personincharge", type: "text", required: true },
  { label: "임대원장", name: "leaseledger", type: "number", required: false },
];

// � 기본 스타일
const styles = {
  container: {
    padding: '2rem',
    display: 'flex',
    justifyContent: 'center',
  },
  form: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '600px',
    width: '100%',
  },
  heading: {
    marginBottom: '1.5rem',
    fontSize: '1.5rem',
    borderBottom: '2px solid #ccc',
    paddingBottom: '0.5rem',
  },
  fieldGroup: {
    marginBottom: '1rem',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    marginBottom: '0.5rem',
  },
  input: {
    width: '100%',
    padding: '0.5rem',
    fontSize: '1rem',
    borderRadius: '6px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  button: {
    marginTop: '1rem',
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  required: {
    color: 'red',
    marginLeft: '4px',
  }
};

export default ProductRequirementForm;
